"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const NotificationsList_1 = tslib_1.__importDefault(require("./views/NotificationsList"));
const Parameters_1 = tslib_1.__importDefault(require("./views/Parameters"));
exports.default = [
    {
        isPublic: false,
        path: '/user/notifications/list',
        element: NotificationsList_1.default
    },
    {
        isPublic: false,
        path: '/user/notifications/params',
        element: Parameters_1.default
    }
];
